<template src="./login-forgotten-password.html"></template>

<script>
import Vue from 'vue'
import { EventBus } from '@/router/bus'
import AlertContainer from '@/components/header/alert-container/AlertContainer.vue'

export default {
  name: 'login-forgotten-password',
  components: { AlertContainer },
  data () {
    return {
      loading: false,
      tabs: null,
      user: {
        login: ''
      }
    }
  },
  methods: {
    resetPassword () {
      this.loading = true
      this.logConsole('Sending password reset request')

      this.$http.put(Vue.$apiConfig.resetUserPost.replace('{login}', this.user.login), this.user)
        .then(response => {
          this.logConsole(response)
          this.loading = false
          this.user.login = null
          this.$nextTick(() => this.$refs.submitUsername.focus())
          EventBus.$emit('alert', {
            variant: 'success',
            message: this.$t('user.passwordResetLinkSent'),
            errors: []
          })
        }, error => {
          this.logConsole(error)
          this.loading = false
          this.formatErrorResponse(error)
        })
    }
  }
}
</script>
